module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-38.ea84c26c.png";